import React, { useContext } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
// material
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// helpers
import { getTimeZoneDate, getTimeZoneGTM } from '../../../helpers/Util';
// context
import { ReportEntryContext } from '../../../contexts/Report/Entry';

export default function AppLastEntriesList() {
  const [searchParams] = useSearchParams();

  const { entries, isLoading, hasError } = useContext(ReportEntryContext);

  const getStatusColor = (status) => {
    switch (status) {
      case 'ENTERED':
        return 'success';
      case 'BLOCKED':
        return 'error';
      default:
        return '';
    }
  };

  const handleClickOrderRow = (orderId) => {
    window.location.href = `/entry/${orderId}?eventId=${searchParams.get('eventId')}`;
  };

  if (hasError) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the last entries — Please, try to refresh the page!
      </Alert>
    );
  }

  return (
    <>
      <Typography sx={{ mt: 4, mb: 2 }} variant="h6">
        Last Entries
      </Typography>

      {isLoading ? (
        <Typography align="center" variant="h3">
          <CircularProgress size={30} color="inherit" />
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 1060 }} size="small" aria-label="a dense table">
            <caption>
              <Button
                variant="outlined"
                to={`/entry/list?eventId=${searchParams.get('eventId')}`}
                component={RouterLink}
              >
                See All
              </Button>
            </caption>
            <TableHead>
              <TableRow>
                <TableCell width="200"># Order Number</TableCell>
                <TableCell width="250">Entry time at</TableCell>
                <TableCell width="150">Gate</TableCell>
                <TableCell width="200">Section</TableCell>
                <TableCell>Tickets</TableCell>
                <TableCell width="170">Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {entries.recents.map((entry) => (
                <TableRow
                  hover
                  key={entry._id}
                  onClick={() => handleClickOrderRow(entry._id)}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }}
                >
                  <TableCell component="th" scope="row">
                    {entry.order.number}
                  </TableCell>
                  <TableCell>
                    {`${getTimeZoneDate({ date: entry.booking.entry.time })
                      .tz('Europe/Lisbon')
                      .format('ddd, DD MMM, HH:mm:ss')}
                      (GTM${getTimeZoneGTM({ date: entry.booking.entry.time })})`}
                  </TableCell>
                  <TableCell>Gate 1</TableCell>
                  <TableCell>
                    {entry.booking.section.single ? ' - ' : entry.booking.section.name}
                  </TableCell>
                  <TableCell>{entry.booking.ticket.name}</TableCell>
                  <TableCell>
                    <Chip
                      label={entry.reasons.length === 0 ? 'ENTERED' : 'BLOCKED'}
                      color={getStatusColor(entry.reasons.length === 0 ? 'ENTERED' : 'BLOCKED')}
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
